import { render, staticRenderFns } from "./ReportCheckListNumber.vue?vue&type=template&id=768f2056&scoped=true&"
import script from "./ReportCheckListNumber.vue?vue&type=script&lang=js&"
export * from "./ReportCheckListNumber.vue?vue&type=script&lang=js&"
import style0 from "./ReportCheckListNumber.vue?vue&type=style&index=0&id=768f2056&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768f2056",
  null
  
)

export default component.exports
import {QCardSection,QItem,QInput} from 'quasar'
component.options.components = Object.assign({QCardSection,QItem,QInput}, component.options.components || {})
